<div class="background-view d-flex justify-content-center align-items-center">
    <div class="d-md-flex flex-wrap gap-2 justify-content-around align-items-center bg-light p-3 rounded border" >
        <div class="mx-2">
            <img width="200px" src="../../../assets/img/background.jpg" alt="logo" class="rounded"/>
        </div>
        <div>
            <form [formGroup]="loginForm"  (ngSubmit)="onSubmit()" class="d-flex flex-column gap-2">
                <mat-form-field >
                    
                    <mat-label><mat-icon class="mx-1">account_circle</mat-icon>username</mat-label>
                    <input matInput formControlName="username"  type="text" name="username" placeholder="username" >
                </mat-form-field>
                <mat-form-field >
                    <mat-label><mat-icon class="mx-1">lock</mat-icon>Password</mat-label>
                    <input matInput formControlName="password" type="password" name="password"  />
                </mat-form-field>
                <div class="d-flex gap-2 align-items-center">
                    <button mat-flat-button color="primary" class="me-3">Sign In</button>
                    <span >or</span>
                    <a mat-button color="primary" routerLink="/register">Sign Up</a>
                </div>
            </form>
        </div>
    </div>
</div>